var exports = {
  "CR": "TableGameLeaderboardModal.module__modalRoot___WVQ2Q1",
  "Zp": "TableGameLeaderboardModal.module__layout___WVQ2Q1",
  "ne": "TableGameLeaderboardModal.module__controls___WVQ2Q1",
  "wx": "TableGameLeaderboardModal.module__header___WVQ2Q1",
  "TK": "TableGameLeaderboardModal.module__headerText___WVQ2Q1",
  "DD": "TableGameLeaderboardModal.module__title___WVQ2Q1",
  "q8": "TableGameLeaderboardModal.module__season___WVQ2Q1",
  "t9": "TableGameLeaderboardModal.module__seasonName___WVQ2Q1",
  "MK": "TableGameLeaderboardModal.module__seasonStatus___WVQ2Q1",
  "Xg": "TableGameLeaderboardModal.module__segmented___WVQ2Q1",
  "rb": "TableGameLeaderboardModal.module__gamePicker___WVQ2Q1",
  "j3": "TableGameLeaderboardModal.module__gameCard___WVQ2Q1",
  "Gt": "TableGameLeaderboardModal.module__gameIcon___WVQ2Q1",
  "mO": "TableGameLeaderboardModal.module__gameName___WVQ2Q1",
  "iW": "TableGameLeaderboardModal.module__main___WVQ2Q1",
  "HU": "TableGameLeaderboardModal.module__aside___WVQ2Q1",
  "p_": "TableGameLeaderboardModal.module__list___WVQ2Q1",
  "JA": "TableGameLeaderboardModal.module__standing___WVQ2Q1",
  "Gf": "TableGameLeaderboardModal.module__sectionTitle___WVQ2Q1",
  "E3": "TableGameLeaderboardModal.module__standingMain___WVQ2Q1",
  "We": "TableGameLeaderboardModal.module__standingBadge___WVQ2Q1",
  "bL": "TableGameLeaderboardModal.module__standingBody___WVQ2Q1",
  "Mp": "TableGameLeaderboardModal.module__standingLeague___WVQ2Q1",
  "sd": "TableGameLeaderboardModal.module__standingPlace___WVQ2Q1",
  "w5": "TableGameLeaderboardModal.module__standingDetail___WVQ2Q1",
  "qB": "TableGameLeaderboardModal.module__progress___WVQ2Q1",
  "z5": "TableGameLeaderboardModal.module__progressTrack___WVQ2Q1",
  "TE": "TableGameLeaderboardModal.module__progressFill___WVQ2Q1",
  "Pc": "TableGameLeaderboardModal.module__progressValue___WVQ2Q1",
  "BY": "TableGameLeaderboardModal.module__standingNote___WVQ2Q1",
  "w7": "TableGameLeaderboardModal.module__standingHint___WVQ2Q1",
};

module.exports = exports;
